<template>
  <div>
    <slot></slot>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import propertyBaseMixin from "../mixins/property-base-mixin";

  export default Vue.extend({
    mixins: [propertyBaseMixin],
    data: function () {
      return {};
    }
  });
</script>
